import { errorHandler, splitUnderscoreString } from '@paysense-india-services/payufin-jsutils'

import { PORTAL_HEADER_KEY } from '@/constants/api'

// Utility function to handle different response types
const parseResponse = async response => {
  const contentType = response.headers.get('Content-Type')

  if (contentType?.includes('application/json')) {
    return response.json()
  } else if (contentType?.includes('text/')) {
    return response.text()
  } else {
    // Handle other content types if needed
    return response.blob()
  }
}

export const getErrorMessage = errorResponse => {
  const { detail, error_code: errorCode, ...rest } = errorResponse || {}
  let errorMessage = ''
  if (errorCode) {
    errorMessage = splitUnderscoreString(errorCode)
  }
  if (typeof detail === 'string') {
    errorMessage = errorMessage ? `${errorMessage} - ${detail}` : detail
  } else if (rest && Object.values(rest)) {
    errorMessage = Object.entries(rest)
      .map(([key, value]) => `${key}: ${Array.isArray(value) ? value[0] : value}`)
      .join('\n')
  }
  return errorMessage
}

const fetchApi = method => {
  return async (url, options = {}, ignoreCredentials = false) => {
    const { params = {}, ...configOptions } = options || {}
    const query = new URLSearchParams(params).toString()
    const apiUrl = query ? `${url}?${query}` : url

    const isFormData = configOptions.body instanceof FormData
    const body = isFormData
      ? configOptions.body
      : configOptions.body
      ? JSON.stringify(configOptions.body)
      : undefined

    try {
      // Detect if the body is FormData (for file uploads)

      const response = await fetch(apiUrl, {
        ...configOptions,
        method,
        headers: {
          ...PORTAL_HEADER_KEY,
          // If it's FormData, do not set 'Content-Type' header. Browser will set it with correct boundary.
          ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
          ...(configOptions.headers || {})
        },
        credentials: ignoreCredentials ? 'same-origin' : 'include',
        // If the body is FormData, don't stringify it
        body
      })

      if (!response.ok) {
        const data = await response?.json()
        const errorInfo = {
          data: { ...data },
          statusCode: response?.status,
          message: getErrorMessage(data) || 'Something went wrong!'
        }
        const errorMessage = errorHandler(errorInfo)

        throw new Error(errorMessage, { cause: errorInfo })
      }
      const resp = await parseResponse(response)
      return resp
    } catch (error) {
      throw new Error(error.message || 'An unexpected error occurred', { cause: error?.cause })
    }
  }
}

const apiService = {
  get: fetchApi('GET'),
  post: fetchApi('POST'),
  put: fetchApi('PUT'),
  delete: fetchApi('DELETE'),
  patch: fetchApi('PATCH')
}

export default apiService
